<template>
	<ModalDialog
		:buttons="[[{name: 'ok', caption: $t('ok'), classes: 'btn-success', clickFn: okClickedHandler, isDisabled: !isModalOkEnabled}]]"
		@escKeyPressed="okClickedHandler"
		size="lg">
		<template v-slot:title>{{ $t(`documents_links_filters`) }}</template>
		<template v-slot:body>
				<div class="position-relative row">
					<div class="col-6 text-left modal-dialog-header sticky-top py-2 d-flex border-right">
						<span class="flex-grow-1 font-weight-semibold">{{ `${$t('category')} / ${$t('subcategory')} ` }}</span>
						<span class="flex-grow-0 clickable" @click="checkAllClickHandler">
							<template v-if="hasElementsFilteredByCategorySubcategory">
								<i class="far fa-check-square mr-1"></i><span class="font-size-80pct">{{ $t('checkAll') }}</span>
							</template>
							<template v-if="!hasElementsFilteredByCategorySubcategory">
								<i class="far fa-square mr-1"></i><span class="font-size-80pct">{{ $t('uncheckAll') }}</span>
							</template>
						</span>
					</div>
					<div class="col-6 modal-dialog-header sticky-top py-2 d-flex">
						<span class="font-weight-semibold">{{ $t('language') }}</span>
					</div>
					<ul class="col-6 documents-links-filter-list list-unstyled mb-0 pt-3 pb-1">
						<li v-for="(category, index) in documentationCategories" :class="index ? 'mt-2' : 'mt-0'">
							<div v-if="category.id !== CONSTANTS.OtherDocuments.categoryId" class="d-flex align-items-center">
								<input type="checkbox" :id="category.id + '-category-checkbox'" class="mr-2" @change="categoryCheckboxChange(category,$event.target.checked)" :checked="category.isDisplayed"  :disabled="!!currentCertificationPackageSelected">
								<label :for="category.id + '-category-checkbox'" class="mb-0">{{ category.title }}</label>
							</div>
							<ul class="list-unstyled pl-3">
								<li v-for="(subcategory) in subcategoriesArray(category.id)" class="mt-1 d-flex align-items-center">
									<input type="checkbox" :id="subcategory.id + '-subcategory-checkbox'" class="mr-2" @change="subcategoryCheckboxChange(subcategory,$event.target.checked)" :checked="subcategory.isDisplayed"  :disabled="!!currentCertificationPackageSelected">
									<label :for="subcategory.id + '-subcategory-checkbox'" class="mb-0">{{ subcategory.title }}</label>
								</li>
							</ul>
						</li>
					</ul>
					<ul class="col-6 documents-links-filter-list list-unstyled mb-0 pt-3">
						<li class="d-flex align-items-start">
							<input type="radio" class="flex-grow-0 mt-1 mr-2" id="showAllLanguages" :checked="allLanguagesSelected" @click="radioButtonShowAllLanguagesClickedHandler"><label for="showAllLanguages" class="flex-grow-1">{{ $t('showAllLanguages') }}</label>
						</li>
						<li class="d-flex align-items-start">
							<input type="radio" class="flex-grow-0 mt-1 mr-2" id="showByLanguages" :checked="!allLanguagesSelected" @click="radioButtonShowByLanguagesClickedHandler">
							<div class="flex-grow-1">
								<label for="showByLanguages" >{{ $t('showByLanguages') }}</label>
								<ul class="list-unstyled">
									<li v-for="(displayedLanguage) in allLanguagesIso6391" class="d-flex align-items-center mb-1">
										<input type="checkbox" :id="displayedLanguage.title + 'language-checkbox'" class="mr-2" :checked="displayedLanguage.isDisplayed" @change="displayedLanguageCheckboxChange(displayedLanguage,$event.target.checked)" :disabled="!!allLanguagesSelected">
										<label class="mb-0" :for="displayedLanguage.title + 'language-checkbox'">{{ `${displayedLanguage.title} - ${$t(displayedLanguage.title)}`  }}</label>
									</li>
								</ul>
							</div>
						</li>
					</ul>
					<div class="col-12 border-top">
						<div class="py-2 font-weight-semibold">{{ $t('defaultFiltersPackages') }}</div>
						<div>
							<template v-for="(button) in documentationPackages">
								<button type="button" class="btn btn-sm mr-3 mb-2" :class="packageMatchingSelection === button.id ? 'btn-primary' : 'btn-outline-primary' " @click="buttonDefaultFilterPackagesClickHandler(button)">{{ button.title }}</button>
							</template>
						</div>
					</div>
					<div class="col-12 border-top">
						<div class="py-2 font-weight-semibold">{{ $t('defaultFiltersPackages') }}</div>
						<div>
							<template v-for="(button) in documentationCertificationsPackages">
								<button type="button" class="btn btn-sm mr-3 mb-2" :class="currentCertificationPackageSelected === button.id ? 'btn-primary' : 'btn-outline-primary' " @click="buttonCertificationsFilterPackagesClickHandler(button.certificationId, button.subcategoriesIds, button.id)">{{ button.title }}</button>
							</template>
						</div>
					</div>
				</div>
		</template>
	</ModalDialog>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import ModalDialog from './ModalDialog.vue';
import { CONSTANTS } from '../resources/constants.js';
import { utilities } from '../resources/utilities.js';

export default {

	data() {
		return {
			allLanguagesSelected: null,
			currentCertificationPackage: null,
			CONSTANTS,
		};
	},

	components: {
		ModalDialog,
	},

	computed: {
		...mapGetters([
			'documentationCertificationsDisplayedIds',
			'documentationLanguagesDisplayedTitle',
			'documentationSubcategoriesDisplayedIds',
		]),
		...mapState([
			'allLanguagesIso6391',
			'documentationCategories',
			'documentationCertifications',
			'documentationCertificationsPackages',
			'documentationPackages',
			'documentationSubcategories',
		]),

		hasElementsFilteredByCategorySubcategory() {
			return this.documentationSubcategoriesDisplayedIds.filter((id) => id !== CONSTANTS.OtherDocuments.subcategoryId).length !== this.documentationSubcategories.filter((sc) => sc.id !== CONSTANTS.OtherDocuments.subcategoryId).length;
		},

		// hasElementsFilteredByCertifications() {
		// 	return this.documentationCertificationsDisplayedIds.length !== this.documentationCertifications.length;
		// },

		isModalOkEnabled() {
			return (this.allLanguagesSelected || this.documentationLanguagesDisplayedTitle.length > 0)
				&& (this.documentationSubcategoriesDisplayedIds.length > 0 || this.documentationCertificationsDisplayedIds.length > 0);
		},

		packageMatchingSelection() {
			const documentationDefaultPackageMatched = this.documentationPackages.find((dp) => JSON.stringify(dp.subcategoriesIds.sort()) === JSON.stringify(this.documentationSubcategoriesDisplayedIds.sort()));
			return documentationDefaultPackageMatched && documentationDefaultPackageMatched.id;
		},

		currentCertificationPackageSelected() {
			return this.currentCertificationPackage;
		},

	},

	methods: {
		...mapMutations([
			'applyDocumentationPackage',
			'applyDocumentationCertificationsPackage',
			'setAllCategoryVisibility',
			'setAllDisplayedLanguagesVisibility',
			'setAllSubcategoryVisibility',
			'setAllCertificationsVisibility',
			'setCategoryDisplayed',
			'setLanguageVisibility',
			'setSubcategoryVisibility',
			'setUserSettings',
			'updateUsageTrackerStorage',
		]),

		...mapActions([
			'getLocalIP',
		]),

		buttonCertificationsFilterPackagesClickHandler(certificationsId, subcategoriesIds, buttonId) {
			// activate all catebories/subcategories
			this.setAllSubcategoryVisibility(false);

			this.setSubcategoryVisibility({ id: CONSTANTS.OtherDocuments.subcategoryId, value: true });
			this.applyDocumentationPackage(subcategoriesIds);
			this.setCategoryDisplayed();

			if (this.currentCertificationPackage === buttonId) {
				// deactivated filter
				this.setAllCertificationsVisibility(false);
				this.currentCertificationPackage = null;

				this.setAllSubcategoryVisibility(true);
			} else {
				this.currentCertificationPackage = buttonId;
				this.applyDocumentationCertificationsPackage({ certificationsId });
			}
		},

		buttonDefaultFilterPackagesClickHandler({ subcategoriesIds, title, id, languages }) {
			this.applyDocumentationPackage(subcategoriesIds);
			this.setCategoryDisplayed();

			if (languages) {
				this.radioButtonShowAllLanguagesClickedHandler();
				this.allLanguagesSelected = false;
				languages.forEach((l) => this.displayedLanguageCheckboxChange(l, true));
			}

			this.setAllCertificationsVisibility(false);
			this.currentCertificationPackage = null;

			this.setUserSettings({ field: CONSTANTS.UserSettings.fieldsKeys.filtersSubcategory, array: this.documentationSubcategoriesDisplayedIds });

			this.getLocalIPAndUpdateUsageTrackerStorage({ field: CONSTANTS.UserSettings.fieldsKeys.documentLinksFilter, data: { isDefaultPackage: true, defaultPackageInfo: { title, id } } });
		},

		categoryCheckboxChange(category, checked) {
			this.setAllCategoryVisibility({ id: category.id, value: checked });
			this.setCategoryDisplayed();
			this.setUserSettings({ field: CONSTANTS.UserSettings.fieldsKeys.filtersSubcategory, array: this.documentationSubcategoriesDisplayedIds });
		},

		checkAllClickHandler() {
			this.setAllSubcategoryVisibility(this.hasElementsFilteredByCategorySubcategory);
			this.setAllCertificationsVisibility(false);
			this.currentCertificationPackage = null;

			this.setUserSettings({ field: CONSTANTS.UserSettings.fieldsKeys.filtersSubcategory, array: this.documentationSubcategoriesDisplayedIds });

			this.getLocalIPAndUpdateUsageTrackerStorage({ field: CONSTANTS.UserSettings.fieldsKeys.documentLinksFilter, data: { checkAllClicked: true, value: !this.hasElementsFilteredByCategorySubcategory } });
		},

		displayedLanguageCheckboxChange(displayedLanguage, checked) {
			this.setLanguageVisibility({ title: displayedLanguage.title, value: checked });
			this.setUserSettings({ field: CONSTANTS.UserSettings.fieldsKeys.filtersLanguage, array: this.documentationLanguagesDisplayedTitle });
		},

		getLocalIPAndUpdateUsageTrackerStorage({ field, data }) {
			this.getLocalIP().then((localIp) => {
				this.updateUsageTrackerStorage({ field, data, localIp });
			});
		},

		okClickedHandler() {
			this.$emit('cancelClicked');

			this.getLocalIPAndUpdateUsageTrackerStorage({ field: CONSTANTS.UserSettings.fieldsKeys.documentLinksFilter, data: { okButtonClicked: true, subcategoriesDisplayed: this.documentationSubcategoriesDisplayedIds, allLanguagesSelected: this.allLanguagesSelected, documentationLanguagesDisplayedTitle: this.documentationLanguagesDisplayedTitle } });
		},

		radioButtonShowAllLanguagesClickedHandler() {
			this.allLanguagesSelected = true;
			this.setAllDisplayedLanguagesVisibility(false);
			this.setUserSettings({ field: CONSTANTS.UserSettings.fieldsKeys.filtersLanguage, array: [] });
		},

		radioButtonShowByLanguagesClickedHandler() {
			this.allLanguagesSelected = false;
		},

		subcategoriesArray(id) {
			return this.documentationSubcategories.filter((sc) => sc.category.id === id && sc.category.id !== CONSTANTS.OtherDocuments.categoryId).sort(utilities.multiCriteriaSort('title', 1));
		},

		subcategoryCheckboxChange(subcategory, checked) {
			this.setSubcategoryVisibility({ id: subcategory.id, value: checked });
			this.setCategoryDisplayed();
			this.setUserSettings({ field: CONSTANTS.UserSettings.fieldsKeys.filtersSubcategory, array: this.documentationSubcategoriesDisplayedIds });
		},

	},

	created() {
		let certificationFilter = this.documentationCertifications.find((dc) => dc.isDisplayed);
		this.allLanguagesSelected = this.documentationLanguagesDisplayedTitle.length === 0;

		if (certificationFilter) {
			this.currentCertificationPackage = this.documentationCertificationsPackages.find((dcp) => dcp.certificationId.includes(certificationFilter.id)).id;
		}
	},
};
</script>

<style lang="scss">
	.documents-links-filter-list {
		overflow-y: auto;
		max-height: 300px;
	}
</style>
